import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import boss from 'boss'
import VueScrollama from 'vue-scrollama'
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
// 调整element-ui主题配色
// 这里我们自定义的css文件需要放在原先引入的"element-ui/lib/theme-chalk/index.css"文件后面，或者把原文件注释掉
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/iconfont/iconfont.css'
import './assets/css/custom-element-ui.less'
import VueResource from 'vue-resource'
import VueLogger from 'vuejs-logger'
import store from './store/store'
import './static/icons'
// 引入echarts
import echarts from 'echarts'
import Print from 'vue-print-nb'

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VueScrollama)
Vue.prototype.$echarts = echarts
Vue.prototype.$boss = boss
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(Print)

// boss
console.log(`boss name:`, boss)

// region Description
const options = {
  // optional : defaults to true if not specified
  isEnabled: true,
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: false,
  // optional : defaults to false if not specified
  showMethodName: true,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: true
}

Vue.use(VueLogger, options)
// 全局mock开关 false关，true开
const mock = true
if (mock) {
  require('./mock')
}
Vue.config.productionTip = false
// endregion

// 节流
const on = Vue.prototype.$on

Vue.prototype.$on = function (event, func) {
  let previous = 0
  let newFunc = func
  // console.log('event', event)
  if (event === 'click') {
    newFunc = function () {
      const now = new Date().getTime()
      if (previous + 1000 <= now) {
        func.apply(this, arguments)
        previous = now
      }
    }
  }
  on.call(this, event, newFunc)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js